import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import './styles.scss';

const LoadingText = ({
  text = 'Loading',
  size = 'md'
}) => {
  const textStyles = {
    sm: 'bodyMd500',
    md: 'bodyLg500',
    lg: 'bodyXxl500',
    xl: 'displaySm'
  };

  return (
    <Text
      className="animatedText"
      textStyle={textStyles[size]}
    >
      {`${text}...`}
    </Text>
  );
};

LoadingText.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export default LoadingText;
